import { useClearSessionStateCache } from "@lending/hooks/queries/useGetSessionQuery";
import { useApi } from "@lending/lib/api";

/**
 * Submits the emailed verification code for an in-flight identity challenge.
 *
 * A successful call returns 204 and sets the lending session cookie, which is
 * what grants the verified-identity principal access to its applications. There
 * is no response body to read; the cookie is the result — so the cached
 * session-state probe (which gates the account menu) must be refreshed.
 */
function useVerifyVerifiedIdentityChallengeMutation() {
  const $api = useApi();
  const clearSessionStateCache = useClearSessionStateCache();

  return $api.useMutation("post", "/v2/lending/verified_identity_challenges/{uuid}/verify/", {
    onSuccess: () => clearSessionStateCache(),
  });
}

export { useVerifyVerifiedIdentityChallengeMutation };
